import React, { useContext, Fragment } from 'react';
import styles from './Footer.module.css';



function Footer_Content(props) {
    return (
        <footer className={styles.footer}>
            <div className={styles.legal_footer}>
                <div className={styles.col}>
                    <Fragment>
                        <b>
                            Always read and follow label directions.
                        </b>
                    </Fragment>
                    <br />
                    <br />
                    <p className={styles.copyright}>
                        {props.copyright}
                    </p>
                    <ul>
                        <li>
                            <a 
                                data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "Disclaimer|/basf_solutions/index/disclaimer_west.html"
                                href="/basf_solutions/index/disclaimer_west.html" target="_blank" rel="noopener noreferrer">Disclaimer</a>
                        </li>
                        <li>
                            <a 
                                data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "Credits|/basf_solutions/index/credits_west.html"
                                href="/basf_solutions/index/credits_west.html" target="_blank" rel="noopener noreferrer">Credits</a>
                        </li>
                        <li>
                            <a 
                                data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "Privacy Policy|/basf_solutions/index/privacy-policy_west.html"
                                href="/basf_solutions/index/privacy-policy_west.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                        </li>                             
                        <li>
                            <a 
                                data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "Trade-marks and Copyright|/basf_solutions/index/trade-marks-and-copyright_west.html"
                                href="/basf_solutions/index/trade-marks-and-copyright_west.html" target="_blank" rel="noopener noreferrer">Trade-marks and Copyright</a>
                        </li>
                        <li>
                            <a 
                                data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "Contact|/basf_solutions/index/contact_west.html"
                                href="/basf_solutions/index/contact_west.html" target="_blank" rel="noopener noreferrer">Contact</a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    )
}

export default Footer_Content;